/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileTagOut
 */
export interface FileTagOut {
    /**
     * 
     * @type {number}
     * @memberof FileTagOut
     */
    fileTagId: number;
    /**
     * 
     * @type {number}
     * @memberof FileTagOut
     */
    attachmentId: number;
    /**
     * 
     * @type {Date}
     * @memberof FileTagOut
     */
    modificationDate: Date;
}

export function FileTagOutFromJSON(json: any): FileTagOut {
    return FileTagOutFromJSONTyped(json, false);
}

export function FileTagOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTagOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileTagId': json['fileTagId'],
        'attachmentId': json['attachmentId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function FileTagOutToJSON(value?: FileTagOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileTagId': value.fileTagId,
        'attachmentId': value.attachmentId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


